import React from 'react';
import { Minus, Plus, Trash2 } from 'lucide-react';
import { CartItem as CartItemType } from '../../lib/types';
import { formatCurrency } from '../../lib/utils';
interface CartItemProps {
  item: CartItemType;
  onUpdateQuantity: (id: string, quantity: number) => void;
  onRemove: (id: string) => void;
}
export function CartItem({
  item,
  onUpdateQuantity,
  onRemove
}: CartItemProps) {
  const optionsTotal = item.selected_options.reduce((sum, opt) => sum + opt.price_delta, 0);
  const unitPrice = item.unit_price_snapshot + optionsTotal;
  const lineTotal = unitPrice * item.quantity;
  return <div className="flex gap-3 py-4 border-b border-white/5 last:border-0" data-id="element-294">
      {/* Image if available */}
      {item.image_url && <div className="w-14 h-14 rounded-xl overflow-hidden bg-[#1a1a1a] shrink-0 border border-white/5" data-id="element-295">
          <img src={item.image_url} alt={item.item_name_snapshot} className="w-full h-full object-cover" data-id="element-296" />
        </div>}

      <div className="flex-1 flex flex-col min-w-0" data-id="element-297">
        <div className="flex justify-between items-start mb-0.5" data-id="element-298">
          <h4 className="font-semibold text-[#F8F5F0] text-sm leading-tight pr-2" data-id="element-299">
            {item.item_name_snapshot}
          </h4>
          <button onClick={() => onRemove(item.id)} className="text-[#F8F5F0]/30 hover:text-[#E63946] transition-colors p-1 -mr-1 shrink-0" aria-label="Eliminar producto" data-id="element-300">
            <Trash2 className="w-4 h-4" data-id="element-301" />
          </button>
        </div>

        {/* Options */}
        {item.selected_options.length > 0 && <ul className="text-xs text-[#F8F5F0]/50 mb-1.5 space-y-0.5" data-id="element-302">
            {item.selected_options.map((opt, idx) => <li key={idx} className="flex justify-between" data-id="element-303">
                <span className="truncate pr-2" data-id="element-304">• {opt.option_name}</span>
                {opt.price_delta > 0 && <span className="shrink-0" data-id="element-305">
                    +{formatCurrency(opt.price_delta)}
                  </span>}
              </li>)}
          </ul>}

        {/* Notes */}
        {item.notes && <p className="text-xs text-[#F4D35E] bg-[#F4D35E]/10 px-2 py-1 rounded-md mb-2 italic line-clamp-2" data-id="element-306">
            "{item.notes}"
          </p>}

        <div className="mt-auto flex items-center justify-between pt-1" data-id="element-307">
          {/* Quantity Controls */}
          <div className="flex items-center bg-[#1a1a1a] rounded-lg p-0.5 border border-white/10" data-id="element-308">
            <button onClick={() => onUpdateQuantity(item.id, item.quantity - 1)} className="w-7 h-7 flex items-center justify-center rounded-md hover:bg-[#2a2a2a] transition-all text-[#F8F5F0]/60 hover:text-[#F8F5F0]" data-id="element-309">
              <Minus className="w-3.5 h-3.5" data-id="element-310" />
            </button>
            <span className="w-7 text-center font-semibold text-sm text-[#F8F5F0]" data-id="element-311">
              {item.quantity}
            </span>
            <button onClick={() => onUpdateQuantity(item.id, item.quantity + 1)} className="w-7 h-7 flex items-center justify-center rounded-md hover:bg-[#2a2a2a] transition-all text-[#F8F5F0]/60 hover:text-[#F8F5F0]" data-id="element-312">
              <Plus className="w-3.5 h-3.5" data-id="element-313" />
            </button>
          </div>

          <div className="font-bold text-[#F4D35E] text-sm" data-id="element-314">
            {formatCurrency(lineTotal)}
          </div>
        </div>
      </div>
    </div>;
}